import axios from 'axios';

export default {
  toggleDrawer({ commit }) {
    commit('toggleDrawer');
  },
  hideSnackbar({ commit }) {
    commit('setSnackbarProps', { show: false });
  },
  showSuccessSnackbar({ commit }, text) {
    let message = text;
    let options = {};
    if (typeof text === 'object' && text !== null) {
      message = text.text;
      if (typeof text.options === 'object' && text.options !== null) {
        // eslint-disable-next-line prefer-destructuring
        options = text.options;
      }
    }
    commit('setSnackbarProps', {
      text: message,
      color: 'success',
      ...options,
    });
  },
  showErrorSnackbar({ commit }, text) {
    let message = text;
    let options = {};
    if (typeof text === 'object' && text !== null) {
      message = text.text;
      if (typeof text.options === 'object' && text.options !== null) {
        // eslint-disable-next-line prefer-destructuring
        options = text.options;
      }
    }
    commit('setSnackbarProps', {
      text: message,
      color: 'error',
      ...options,
    });
  },
  showInfoSnackbar({ commit }, text) {
    let message = text;
    let options = {};
    if (typeof text === 'object' && text !== null) {
      message = text.text;
      if (typeof text.options === 'object' && text.options !== null) {
        // eslint-disable-next-line prefer-destructuring
        options = text.options;
      }
    }
    commit('setSnackbarProps', {
      text: message,
      color: 'info',
      ...options,
    });
  },
  login(_, data) {
    return axios.post('/Access/LoginAsync', data);
  },
  resetPassword(_, data) {
    return axios.post('Access/ResetPasswordRequest?id='+data.Email);
  },
  changePassword(_, { email, password, oobCode }) {
    return axios.post('Access/ResetPassword', { email, password, oobCode });
  },
  hideOverlay({ commit }) {
    commit('hideOverlay');
  },
  showOverlay({ commit }) {
    commit('showOverlay');
  },
};
